import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-print-gcp',
  templateUrl: './print-gcp.component.html',
  styleUrls: ['./print-gcp.component.scss']
})
export class PrintGcpComponent implements OnInit {

    public ngxExtendedPdfViewerConfig: any = {
        printResolution: 600 // Define a resolução de impressão como 300 DPI
    };

    pdf: any;

    constructor(public dialogRef: MatDialogRef<PrintGcpComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

    }
    ngOnInit(): void {
        console.log("Imprindo...");
        this.pdf = null;
        this.pdf = this.data.pdf
    }

}
